import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { reporteVentas } from "../../../../service/cortesias/cortesias";
import { ReporteVentasModel, VentasProductosModel } from "../models/ReporteVentasModel";

export const useReporteVentas = (realoadGrid: number, ids_dia: number[], id_caja: number, nombreProducto: string) => {

  const [list, setList] = useState<VentasProductosModel[]>([]);
  const [ingresos, setIngresos] = useState<ReporteVentasModel>({
    ingreso_efectivo: 0,
    ingreso_tarjeta: 0,
  });
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await reporteVentas(ids_dia, id_caja, nombreProducto)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res.ventas_producto);
        setIngresos(res);
        setLoadingRequest(false);
      }
    };
    fetchPost();

  }, [realoadGrid, ids_dia.join(','), id_caja, nombreProducto]); // eslint-disable-line react-hooks/exhaustive-deps

  return { list, ingresos, loadingRequest };
};
